import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Drawer, Paper } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { getConditionalObject } from 'utils/data';

import { setIsSidebarOpenAction } from 'store/global/actions';
import { selectIsSidebarInDrawer, selectSidebarState } from 'store/global/selectors';

import { ContentLayoutPropTypes, defaultSidebarComponent } from '../ContentLayout.constants';

import { getSidebarStyles, sidebarDrawerPaperStyles } from './Sidebar.styles';

const Sidebar = ({ children, wrapperRef, options }) => {
  const dispatch = useDispatch();

  const isSidebarInDrawer = useSelector(selectIsSidebarInDrawer);
  const { isOpen } = useSelector(selectSidebarState);

  const { SidebarWrapper, sidebarWrapperProps } = useMemo(() => {
    return {
      SidebarWrapper: isSidebarInDrawer ? Drawer : React.Fragment,
      sidebarWrapperProps: getConditionalObject(isSidebarInDrawer, {
        anchor: 'left',
        open: isOpen,
        onClose: () => dispatch(setIsSidebarOpenAction(false)),
        container: () => wrapperRef.current,
        PaperProps: {
          sx: sidebarDrawerPaperStyles,
        },
        ModalProps: {
          keepMounted: true,
        },
      }),
    };
  }, [isSidebarInDrawer, isOpen, wrapperRef, dispatch]);

  return (
    <SidebarWrapper {...sidebarWrapperProps}>
      <Paper
        className={clsx('page-sidebar', options?.className)}
        component={options?.component ?? defaultSidebarComponent}
        sx={getSidebarStyles(options)}
        {...options?.props}
      >
        {children}
      </Paper>
    </SidebarWrapper>
  );
};

Sidebar.propTypes = {
  wrapperRef: PropTypes.object.isRequired,
  options: ContentLayoutPropTypes.sidebarOptions.isRequired,
};

export default memo(Sidebar);
